import { createAction } from '@reduxjs/toolkit';

export const resetSystemConnectionStore = createAction(
	'metadata/systemConnections/reset',
);

export const resetConfigurationsStore = createAction(
	'metadata/configurations/reset',
);
